import {IElement} from '../../../incase-domain/elements';
import {interactiveWithTryButton} from '../../../incase-domain/elements/base/ElementTypes';
import {IElementQuestion} from '../../../incase-domain/elements/question/question';
import {ISlide} from '../../../incase-domain/slide';
import {getDifference, removeElementFromArray, swapArrayElement} from '../../../utils/utils';

export function getRandomDisplacement(position: number, dimensionStr: string): number {
    const dimension = Number(dimensionStr.slice(0, dimensionStr.length - 1));
    if (position + dimension > 85) {
        if (dimension >= 85) {
            if (position === 0) {
                return Math.random() * (100 - dimension);
            }
            return 0;
        }
        return position - Math.random() * 15;
    }
    return position + Math.random() * 15;
}

export function addHighlightedIdToDisplayProperty(elements: IElement[], newHighlightedElement: IElement): IElement[] {
    const {elementToDisplayAfterClick, elementToClickForDisplay} = newHighlightedElement;

    const oldElementToDisplayAfterClick = elements.find((el) => el.id === newHighlightedElement.id)?.elementToDisplayAfterClick;
    const oldElementToClickForDisplay = elements.find((el) => el.id === newHighlightedElement.id)?.elementToClickForDisplay;

    return (elements || []).map((element) => {
        const tempEl = {...element};

        const isInHighlightedClickForDisplay = elementToClickForDisplay?.includes(element.id);
        const isInOldClickForDisplay = oldElementToClickForDisplay?.includes(element.id);
        const hasClickForDisplayChanged = isInHighlightedClickForDisplay !== isInOldClickForDisplay;

        const isInHighlightedDisplayAfterClick = elementToDisplayAfterClick?.includes(element.id);
        const isInOldDisplayAfterClick = oldElementToDisplayAfterClick?.includes(element.id);
        const hasDisplayAfterClickChanged = isInHighlightedDisplayAfterClick !== isInOldDisplayAfterClick;

        if (hasClickForDisplayChanged) {
            if (isInHighlightedClickForDisplay) {
                tempEl.elementToDisplayAfterClick = [...(element.elementToDisplayAfterClick || []), newHighlightedElement.id];
            } else {
                tempEl.elementToDisplayAfterClick = removeElementFromArray(
                    element.elementToDisplayAfterClick || [],
                    newHighlightedElement.id
                );
            }
        }

        if (hasDisplayAfterClickChanged) {
            if (isInHighlightedDisplayAfterClick) {
                tempEl.elementToClickForDisplay = [...(element.elementToClickForDisplay || []), newHighlightedElement.id];
            } else {
                tempEl.elementToClickForDisplay = removeElementFromArray(element.elementToClickForDisplay || [], newHighlightedElement.id);
            }
        }

        return tempEl;
    });
}

export function handleOnBeforeAfterChange(element: IElement, field: keyof IElement, value: unknown): IElement {
    const ON_CLICK_FIELDS = ['elementToDisplayAfterClick', 'elementToClickForDisplay'];

    if (!ON_CLICK_FIELDS.includes(field)) return element;

    const tempEl = {...element};

    if (field === 'elementToDisplayAfterClick') {
        tempEl.elementToClickForDisplay = getDifference(tempEl.elementToClickForDisplay || [], value as string[]);
    }

    if (field === 'elementToClickForDisplay') {
        tempEl.elementToDisplayAfterClick = getDifference(tempEl.elementToDisplayAfterClick || [], value as string[]);
    }

    return tempEl;
}

export function handleHighlightedElementChange(
    slide: ISlide,
    highlightedElementIndex: number,
    updateSlide: (slide: ISlide) => void,
    newHighlightedElement: IElement
): void {
    const tempHighlighted = {...newHighlightedElement};

    if (interactiveWithTryButton.includes(tempHighlighted.type)) {
        if (!(tempHighlighted as IElementQuestion).haveTryButton) tempHighlighted.elementToDisplayAfterClick = [];
    }

    const newElements = swapArrayElement(
        addHighlightedIdToDisplayProperty(slide.elements, tempHighlighted),
        highlightedElementIndex,
        tempHighlighted
    );

    updateSlide({...slide, elements: newElements});
}
